var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-image',{staticStyle:{"width":"100%","height":"600px"},attrs:{"src":_vm.$domain + 'static/noten/website/newHome/top_banner1.png',"alt":"编程"}}),_vm._v(" "),_c('Idea'),_vm._v(" "),_c('Works')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba101272","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/creation/index.vue
// module id = null
// module chunks = 